import BaseAppService from 'application/platform/base-app.service';
import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';


var url = window.location.hostname.toLowerCase();
if (url.includes("-dev")) {
  axios.defaults.baseURL = "https://api-municipalportal-dev.munidados.com.br";
} else if (url.includes("localhost")) {
  axios.defaults.baseURL = "https://localhost:7250/";
  // axios.defaults.baseURL = "https://api-municipalportal-dev.munidados.com.br";
} else {
  axios.defaults.baseURL = "https://api-municipalportal.munidados.com.br";
}

axios.defaults.paramsSerializer = {
  serialize: function (params: any) {
    return qs.stringify(params, { indices: false });
  }
}

const executeRequest = async (config: AxiosRequestConfig) => {
  let data = null;

  const applicationData = BaseAppService.getApplicationData();

  config.headers = {
    Authorization: `Bearer ${applicationData?.token}`,
  }

  const result = await axios.request(config);
  data = result.data;

  return { data };
};

axios.interceptors.response.use(
  (response) => {
    // Manipulate the response data if needed
    return response;
  },
  (error) => {
    console.log(error);
    // Handle errors globally
    return Promise.reject(error);
  }
);

const HttpClient = {
  executeRequest
};

export default HttpClient;